import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        list_players: {
          view_player: {
            header: 'PLAYER_DETAILS_HEADER',
            tabs: {
              main_data: {
                tab_name: 'MAIN_DATA_TAB_NAME',
              },
              activities_player: {
                tab_name: 'ACTIVITY_TAB_NAME',
              },
              tracker_player: {
                tab_name: 'TRACKER_NAME_TAB_NAME',
              },
            },
          },
        },
      },
    },
  }));
}
